export default "__VITE_ASSET__BEcT_DHQ__"